import Carousel from './carousel';

class HeroNavMobileCarousel extends Carousel {
  constructor(el: any, settings: object = {}) {
    const TIME = 8000;
    const SPEED = 800;

    const pagination: HTMLElement | null | undefined = el?.parentElement?.querySelector('.o-hero-nav__mobile__pagination');

    super(el, {
      ...settings,
      effect: 'slide',
      speed: SPEED,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      // autoplay: false,
      parallax: true,
      // autoplay: {
      //   delay: TIME,
      //   disableOnInteraction: false,
      // },
      centeredSlides: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: (swiper: any) => {
          setTimeout(() => {
            swiper.removeSlide(swiper.slides.length - 3);
          }, 2050);
          // // pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);

          // if (swiper.slides.length - 2 <= 1) {
          //   swiper.autoplay.stop();
          //   swiper.unsetGrabCursor();
          //   swiper.params.grabCursor = false;
          //   //swiper.params.loop = false;
          //   el?.classList.add('swiper-no-swiping');
          // }
        },
      },
    });
  }
}

export default HeroNavMobileCarousel;
